module.exports = __webpack_public_path__ + "static/media/film.482a96f7.svg";